var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    fill: "#E85130"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1196 61.1646C30.1196 48.0848 37.2721 37.1244 46.892 34.2363C45.2679 33.748 43.5709 33.4883 41.8322 33.4883C29.7761 33.4883 20 45.8824 20 61.1646C20 76.4468 29.7761 88.8409 41.8322 88.8409C43.5709 88.8409 45.2679 88.5811 46.892 88.0928C37.2721 85.2047 30.1196 74.2443 30.1196 61.1646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.625 61.167C38.625 77.8413 47.006 91.4613 57.5525 92.334V92.2093C52.399 90.5782 48.3803 77.3011 48.3803 61.167C48.3803 45.0329 52.399 31.7661 57.5525 30.1247V30C47.006 30.8727 38.625 44.4927 38.625 61.167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4574 33.4889C79.7188 33.4889 78.0218 33.7486 76.3976 34.2369C86.0175 37.1354 93.17 48.0854 93.17 61.1652C93.17 74.2449 86.0175 85.2053 76.3872 88.0935C78.0113 88.5818 79.7084 88.8415 81.447 88.8415C93.5032 88.8415 103.279 76.4474 103.279 61.1652C103.279 45.8726 93.5032 33.4889 81.447 33.4785L81.4574 33.4889Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6741 61.167C84.6741 44.4927 76.2931 30.8727 65.7466 30V30.1247C70.9001 31.7557 74.9188 45.0329 74.9188 61.167C74.9188 77.3011 70.9001 90.5679 65.7466 92.2093V92.334C76.2931 91.4613 84.6741 77.8413 84.6741 61.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/PUMP.e34742b45937265a58efd0bada18e6d1.svg";
export { ForwardRef as ReactComponent };